// eslint-disable-next-line space-infix-ops
export const mySportsGenrePkgFilter = (packages, genreConfig, queryParams, categoryView=false) => {
  // eslint-disable-next-line eqeqeq
  const filterPackges = (packages, filterName) => packages.filter(pack => pack?.billingCodeLabel?.toLowerCase() != filterName?.toLowerCase());
  let mySportsFlag = false;
  // eslint-disable-next-line eqeqeq
  const mySportsPackage = packages.filter(pack => pack?.billingCodeLabel?.toLowerCase() == 'mysports');
  if (mySportsPackage && Object.keys(mySportsPackage).length > 0 && genreConfig) {
    const mysportsPackageId = mySportsPackage?.[0]?.packageId;
    mySportsFlag = genreConfig[mysportsPackageId];
  }
  if (queryParams && queryParams?.pkg) {
    // eslint-disable-next-line eqeqeq, no-param-reassign
    packages = packages.filter(pack => pack?.billingCodeLabel?.toLowerCase() == queryParams?.pkg.toLowerCase());
  } else if (queryParams && queryParams?.cmprPkg) {
    // eslint-disable-next-line eqeqeq
    if (mySportsFlag && queryParams?.cmprPkg?.toLowerCase() == 'premier') {
      // eslint-disable-next-line no-param-reassign
      packages = filterPackges(packages, 'mysports');
    } else {
      // eslint-disable-next-line no-param-reassign
      packages = filterPackges(packages, 'premier');
    }
  } else {
    if (!mySportsFlag || (queryParams && queryParams?.isPremier === 'true')) {
      // eslint-disable-next-line no-param-reassign
      packages = filterPackges(packages, 'mysports');
    } else if (mySportsFlag) {
      if ( !categoryView )
        // eslint-disable-next-line curly, no-param-reassign
        packages = filterPackges(packages, 'premier');
    }
  }
  return {
    packages,
    mySportsFlag
  }
};

export const mySportsBetaPkgFilter = (
  packages,
  queryParams,
  isChannelLineUpPage = false,
  msbNationalRollOut
) => {
  if (
    queryParams?.showPkg === "mysportsbeta" ||
    // eslint-disable-next-line eqeqeq
    queryParams?.cmprPkg?.toLowerCase() == "mysportsbeta" ||
    queryParams?.pkg?.toLowerCase?.() === "mysportsbeta" ||
    // eslint-disable-next-line eqeqeq
    isChannelLineUpPage || (msbNationalRollOut && queryParams?.pkg == undefined)
  ) {
    const mySportsPackage = packages.find(
      pack => pack?.packageId === "ATT_TV_MYSPORTSBETA"
    );
    // eslint-disable-next-line no-param-reassign
    packages = packages?.filter?.(
      pack => pack?.packageId !== "ATT_TV_MYSPORTSBETA"
    );
    if(mySportsPackage) {
      packages?.unshift?.(mySportsPackage);
    }
  } else if(!isChannelLineUpPage && queryParams?.showPkg !== "mysportsbeta"){
    // eslint-disable-next-line no-param-reassign
    packages = packages.filter(
      pack => pack?.packageId !== "ATT_TV_MYSPORTSBETA"
    );
  }

  return packages
};

export const createPackageOrderMap = packageConfig => packageConfig?.reduce((map, pkg, index) => {
  if (pkg.order) {
    map[pkg.id] = parseInt(pkg.order, 10);
  } else {
    map[pkg.id] = index;
  }
  return map;
}, {});

// eslint-disable-next-line arrow-spacing, comma-spacing, space-infix-ops
export const sortGenrepack = (genrePackages,packageConfig,component=undefined) =>{
  try{
    const packageOrderMap = createPackageOrderMap(packageConfig);
    const parsedOptions = Array.isArray(genrePackages.options) ?
      genrePackages.options.map(option => {
        const [name, packageId] = option.split(',');
        return {
          name,
          packageId: packageId?.trim()
        };
      }) :
      Array.isArray(genrePackages) ?
        genrePackages.map(pkg => {
          if (typeof pkg === 'string') {
            return { packageId: pkg?.trim() };
          }
          return {
            ...pkg,
            packageId: (pkg?.packageId || pkg?.packageKey).trim()
          };
        }) :
        [];
    // eslint-disable-next-line no-confusing-arrow
    const normalizePackageId = packageId => packageId.startsWith('ATT_TV_') ? packageId : `ATT_TV_${packageId}`;
    const sortedOptions = parsedOptions
      .filter(option => {
        const normalizedPackageId = normalizePackageId(option?.packageId);
        const exists = packageOrderMap[normalizedPackageId] !== undefined;
        if (!exists) {
          console.warn(`Package ID ${normalizedPackageId} not found in packageOrderMap`);
        }
        return exists;
      })
      .sort((a, b) => {
        const orderA = packageOrderMap[normalizePackageId(a?.packageId)];
        const orderB = packageOrderMap[normalizePackageId(b?.packageId)];
        return orderA - orderB;
      });
    // Extract the sorted packageId values into genreSortKeyArray
    const genreSortKeyArray = sortedOptions.map(option => option.packageId);
    if (component === "channelpacklineup") {
      genrePackages.sort((a, b) => {
        const orderA = packageOrderMap[a?.packageKey];
        const orderB = packageOrderMap[b?.packageKey];
        return (orderA !== undefined && orderB !== undefined) ? orderA - orderB :
          (orderA !== undefined) ? -1 :
            (orderB !== undefined) ? 1 :
              0;
      });
      return genrePackages;
    }
    return genreSortKeyArray;
  } catch (e) {
    console.log("Error in sorting genre pack", e);
    return genrePackages; // Return unsortedgenrePackages in case of an error
  }
}

export const addGenrePackages = (packages, genrePackages, packageConfig) => {
  const addPackages = packagesList => {
    packagesList?.forEach?.(genrePkg => {
      packages.push(genrePkg);
    });
  };

  if (!packageConfig || !Array.isArray(packageConfig) || packageConfig.length === 0) {
    addPackages(genrePackages);
    return packages;
  }

  const packageOrderMap = createPackageOrderMap(packageConfig);
  const sortedGenrePackages = genrePackages
    // eslint-disable-next-line no-prototype-builtins
    .filter(genrePkg => packageOrderMap.hasOwnProperty(genrePkg?.packageId))
    .sort((a, b) => packageOrderMap[a?.packageId] - packageOrderMap[b?.packageId]);

  addPackages(sortedGenrePackages);
  return packages;
};

// eslint-disable-next-line arrow-spacing
export const addMySportsBetaGenrePackage = (packages, genrePackages) =>{
  // eslint-disable-next-line array-callback-return, arrow-spacing
  genrePackages?.map?.(genrePkg=>{
    const genrePkgId = genrePkg?.packageId
    if(genrePkgId === "ATT_TV_MYSPORTSBETA"){
      packages.push(genrePkg);
    }
  });
  return packages;
}

export const extractGenreTooltips = genrePackages => {
  try{
    return genrePackages?.reduce((acc, genrePackage) => {
      if (genrePackage?.packageId && genrePackage?.tooltip) {
        acc[genrePackage.packageId] = genrePackage.tooltip;
      }
      return acc;
    }, {});
  } catch(_e){
    return {};
  }
}

